import ProductGrid from './ProductGrid';
import compose from 'recompose/compose';
import withProps from 'recompose/withProps';
import formatPrismicData from '../../hocs/formatPrismicData';
import { withModel } from '../../data-providers/model';
import {
  getAvailableProductIds,
  findLowestProductPrice
} from 'src/common/utils/product';
import { localiseUrl } from 'src/common/utils/format-localised-url';
import withCountry from '../../hocs/withCountry';
import withMedia from 'src/client/js/view/hocs/withMediaQueries';
import { replaceTextWithValues } from 'src/common/utils/text-replace';
import withState from 'recompose/withState';
import withGlobalContent from '../../hocs/withGlobalContent';
import get from 'lodash/get';

const enhance = compose(
  formatPrismicData,
  withModel,
  withCountry,
  withGlobalContent,
  withProps(props => {
    const {
      eagleModel: { products },
      countryModel
    } = props.model;

    const availableProductIds = getAvailableProductIds(products);

    const globalAgeRangeLabel = get(
      props,
      'globalContent.general.ageRangeLabel',
      'Ages %{minAge}-%{maxAge}'
    );

    return {
      ctaLabel: get(props, 'globalContent.general.cardCtaLabel', ''),
      ctaCloseLabel: get(props, 'globalContent.general.cardCtaCloseLabel', ''),
      products,
      availableProductIds,
      items: props.items
        .filter(item =>
          availableProductIds.includes(item.product.main.productId)
        )
        .map(item => {
          const priceObj = findLowestProductPrice(
            products,
            item.product.main.productId,
            {
              locale: countryModel.locale
            }
          );

          return {
            ...item,
            ...priceObj,
            ageRangeLabel: replaceTextWithValues(globalAgeRangeLabel, {
              minAge: item.product.productInformation.minimumAge,
              maxAge: item.product.productInformation.maximumAge
            }),
            priceLabel: replaceTextWithValues(
              item.priceLabel || 'From %{price}',
              { price: priceObj.price.formatted }
            ),
            url: localiseUrl(
              countryModel,
              `/personalized-products/${item.product.productInformation.productSlug}`
            )
          };
        })
        .filter(item => item.price)
    };
  }),
  withState('expandedId', 'setExpandedId', props =>
    get(props, 'expandedId', null)
  ),
  withMedia
);

export default enhance(ProductGrid);



// WEBPACK FOOTER //
// ./src/client/js/view/components/ProductGrid/index.js